import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { GetMyManagedTeamsUseCase } from '@features/investigations';

export const investigationsHasTeamsGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(GetMyManagedTeamsUseCase)
    .execute()
    .pipe(
      map((teams) => (teams.length > 0 ? true : router.parseUrl('/investigations/dashboard'))),
      catchError(() => of(router.parseUrl('/investigations/dashboard'))),
    );
};
